import { render } from "./Formacion.vue?vue&type=template&id=24f3f9d2&scoped=true"
const script = {}

import "./Formacion.vue?vue&type=style&index=0&id=24f3f9d2&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f3f9d2"]])

export default __exports__